import { LicenseModel } from './createLicenseModel';
import { DateTime } from 'luxon';

export const dummyLicense: LicenseModel = {
  id: '3859476328585673',
  key: 'tgEgAUDiAQtgEgAUDiAQtgEgAUDiAQtgEgAUDiAQ',
  status: 'active',
  licenseType: 'Floating License Yearly',
  subscriptions: [
    {
      id: 'id',
      subscriptionNumber: 'A-S00001517',
      status: 'active',
      licenseKey: '12345',
      licenseType: 'Fixed License Monthly',
      seats: 1,
      alteredSeats: 0,
      serviceActivationDate: DateTime.local(),
      invoiceOwnerAccountId: '12345',
    },
  ],
  seats: 1,
  creationDate: DateTime.local(),
};
